import type { ReactNode } from 'react';
import React, { Children, Fragment, useState } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { UnmountClosed } from 'react-collapse';
import { styles } from './Capsule.styles';
const SMALL: 'small' = 'small';
const LARGE: 'large' = 'large';
const AUTO: 'auto' = 'auto';
const NONE: 'none' = 'none';
type Props = {
  additionalStyle?: {
    root?: {};
    header?: {};
    content?: {};
    icon?: {};
    label?: {};
  };
  children?: ReactNode;
  className?: string;
  color?: string;
  contentClassName?: string;
  dataTestId?: string;
  header?: typeof SMALL | typeof LARGE | typeof AUTO | typeof NONE;
  icon?: IconName;
  label?: string;
  upside?: boolean;
  validated?: boolean;
  isAccordion?: boolean;
};
export const Capsule = ({
  additionalStyle,
  children,
  className,
  color,
  contentClassName,
  header = SMALL,
  icon = ICONS.ALL_INCLUSIVE,
  label,
  upside,
  validated,
  isAccordion = false,
  dataTestId,
}: Props) => {
  const isLargeHeader = header === LARGE;
  const isHeaderNone = header === NONE;
  const isHeaderAuto = header === AUTO;
  const {
    computedCapsuleStyle,
    computedCheckIconStyle,
    computedContentStyle,
    computedHeaderStyle,
    computedHeaderFullStyle,
    computedHeaderFullStyleCollapsed,
    computedIconWrapperStyle,
    computedLabelStyle,
    computedChevronIconlStyle,
  } = styles({
    additionalStyle,
    color,
    isHeaderNone,
    isLargeHeader,
    isHeaderAuto,
    upside,
  });
  const [displayed, setDisplayed] = useState(!isAccordion ? true : false);

  if (!Children.count(children)) {
    return null;
  }

  const toggleDisplay = () => {
    setDisplayed((display) => !display);
  };

  const custsomAccordionStyle = () => {
    if (isAccordion) {
      if (displayed) {
        return computedHeaderFullStyle;
      }

      return computedHeaderFullStyleCollapsed;
    }

    return computedHeaderStyle;
  };

  return (
    <section
      className={classnames('Capsule', className)}
      style={computedCapsuleStyle}
      data-testid={dataTestId}
    >
      {header !== 'none' && (
        <div onClick={isAccordion ? toggleDisplay : () => {}} style={custsomAccordionStyle()}>
          {(isLargeHeader || isHeaderAuto) && (
            <Fragment>
              <div className="flex items-center">
                <div style={computedIconWrapperStyle}>
                  <Icon name={icon} width={computedIconWrapperStyle.width || '1.25rem'} />
                </div>
                <span style={computedLabelStyle}>{label}</span>
              </div>
              {isAccordion && (
                <span style={computedChevronIconlStyle}>
                  <Icon
                    name="select"
                    width="1em"
                    className={classnames('flex', {
                      'rotate-180 transform': displayed,
                    })}
                  />
                </span>
              )}
            </Fragment>
          )}
        </div>
      )}
      <div className={contentClassName} style={computedContentStyle}>
        {validated && (
          <div className="relative">
            <div style={computedCheckIconStyle}>
              <Icon className="text-success" name={ICONS.CHECK_OUTLINE} width="3rem" />
            </div>
          </div>
        )}
        {isAccordion ? <UnmountClosed isOpened={displayed}>{children}</UnmountClosed> : children}
      </div>
    </section>
  );
};
